// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"c193669d","481":"e0f68d8c","648":"6c1111a2","787":"b0823f7d"}[chunkId] + ".chunk.js";
};